import React, { ReactNode } from 'react';

import * as S from './TextSection.styles';

export interface TextSectionProps {
  title: string;
  variant: 'primary' | 'secondary';
  useBulletPoints: boolean;
  textContent: ReactNode[];
}

export const TextSection = ({
  title,
  variant,
  useBulletPoints,
  textContent,
}: TextSectionProps) => {
  return (
    <S.Root $variant={variant}>
      <S.TitleLabel $variant={variant}>{title}</S.TitleLabel>
      <S.TextContentWrapper>
        {textContent.map((text, index) => (
          <S.TextWrapper key={index}>
            {useBulletPoints && <S.BulletItem />}
            <div>{text}</div>
          </S.TextWrapper>
        ))}
      </S.TextContentWrapper>
    </S.Root>
  );
};
